import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ConsumptionChart, DashboardStatCards, UsageComparison24h } from "@/components/dashboard";
import { DEFAULT_SHARED_TIME_RANGE } from "@/constants/timeRange";
import { useDashboardData } from "../../hooks/useDashboardData";
import { DashboardPageLayout } from "@/layouts/DashboardPageLayout";
export default function DashboardPage() {
    const [timeRange, setTimeRange] = useState(DEFAULT_SHARED_TIME_RANGE);
    const { stats, usageComparison24h, consumptionChart, isLoading, error } = useDashboardData();
    return /*#__PURE__*/ _jsxs(DashboardPageLayout, {
        title: "Dashboard",
        description: "Real-time health, delivery performance & entropy pool status",
        children: [
            /*#__PURE__*/ _jsx(DashboardStatCards, {
                stats: stats,
                isLoading: isLoading
            }),
            /*#__PURE__*/ _jsx(UsageComparison24h, {
                data: usageComparison24h,
                isLoading: isLoading
            }),
            /*#__PURE__*/ _jsx(ConsumptionChart, {
                data: consumptionChart,
                isLoading: isLoading,
                timeRange: timeRange,
                onTimeRangeChange: setTimeRange
            }),
            error && /*#__PURE__*/ _jsxs("p", {
                className: "text-sm text-red-500",
                children: [
                    "Some data failed to load: ",
                    error.message
                ]
            })
        ]
    });
}
